import axiosConfig from "./axiosConfig";

export const getAllRubriques = async () => {
    try {
        const response = await axiosConfig.get('v1/rubriques');
        return response.data;
    } catch (error) {
        console.error('Error fetching rubriques:', error);
        throw error;
    }
}

export const getRubriqueById = async (id) => {
    try {
        const response = await axiosConfig.get(`v1/articles/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error getting rubrique by id:', error);
        throw error;
    }
}